var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.056 14.4581V10.3044C10.056 10.084 9.96851 9.87274 9.81271 9.71695C9.65692 9.56116 9.44562 9.47363 9.22529 9.47363H6.73308C6.51276 9.47363 6.30145 9.56116 6.14566 9.71695C5.98987 9.87274 5.90234 10.084 5.90234 10.3044V14.4581",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 7.61306C2.16602 6.48492 2.16602 5.92085 2.39364 5.4249C2.62209 4.92895 3.04992 4.56259 3.90641 3.82822L4.73715 3.11628C6.28647 1.78959 7.05906 1.125 7.98118 1.125C8.90329 1.125 9.67671 1.78876 11.2252 3.11545L12.0559 3.82739C12.9116 4.56176 13.3403 4.92812 13.5679 5.42407C13.7963 5.92002 13.7963 6.48409 13.7963 7.61223V11.1354C13.7963 12.7022 13.7963 13.4847 13.3095 13.9715C12.8227 14.4583 12.0402 14.4583 10.4734 14.4583H5.48896C3.92219 14.4583 3.13964 14.4583 2.65283 13.9715C2.16602 13.4847 2.16602 12.7022 2.16602 11.1354V7.61306Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4caee3e237cd16ff6829de99d7849cda.svg";
export { ForwardRef as ReactComponent };